var map = {
	"./info_bike_factory.svg": 874,
	"./info_hire_employee.svg": 875,
	"./info_microchip_factory.svg": 876,
	"./info_microchip_reuse_facility.svg": 877,
	"./info_mobile_phone_factory.svg": 878,
	"./info_product_refurbishing_facility.svg": 879,
	"./info_product_refurbishing_facility_bike.svg": 880,
	"./info_rental_maintenance_service.svg": 881,
	"./info_rental_maintenance_service_bike.svg": 882,
	"./info_repair_workshop.svg": 883,
	"./info_resource_efficiency_bike.svg": 884,
	"./info_resource_efficiency_microchip.svg": 885,
	"./info_resource_efficiency_mobile.svg": 886,
	"./info_resource_substitution_bike.svg": 887,
	"./info_resource_substitution_microchip.svg": 888,
	"./info_resource_substitution_mobile.svg": 889,
	"./info_waste_recycling.svg": 890,
	"./marketprice_bike.svg": 891,
	"./marketprice_microchip.svg": 892,
	"./marketprice_mobile.svg": 893
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/investments/info nonrecursive ./~/raw-loader!\.svg$
// module id = 478
// module chunks = 2